angular.module('dnecom')
    .directive('inputColorpicker', function() {
        return {
            type: 'E',
            replace: true,
            transclude: true,
            require: "^^form",
            template: '<div class="form-group">\n    <label for="{{ uid }}">\n        <ng-transclude></ng-transclude>\n    </label>\n    <div class="input-group color-select-group">\n        <span class="input-group-addon" style="background: {{ model }};"></span>\n        <input type="text" name="{{ uid }}" class="form-control" id="{{ uid }}" colorpicker required\n               tooltip-trigger="mouseenter" uib-tooltip="{{ tooltip }}"\n               ng-pattern="/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i" ng-model="model">\n        <span class="input-group-btn" ng-if="default.length > 0" ng-show="model != default">\n            <button class="btn btn-danger" type="button" tooltip-trigger="mouseenter" uib-tooltip="Reset to default" ng-click="reset()">\n                <i class="fa fa-times"></i>\n            </button>\n        </span>\n    </div>\n    <form-errors element="form[uid]" error-messages="errorMessages"></form-errors>\n</div>',
            scope: {
                model: '=ngModel',
                errorMessages: '=?',
                default: '@',
                tooltip: '@'
            },
            link: function link(scope, element, attrs, FromCtrl) {
                scope.form = FromCtrl;
                scope.uid = Math.random().toString(36).substr(2);
                scope.model = scope.model.length > 0 ? scope.model : scope.default;
                scope.errorMessages = _.isUndefined(scope.errorMessages) ? [{ type: 'pattern', text: 'Color must be valid hex color string' }] : scope.errorMessages;

                scope.reset = function () {
                    scope.model = scope.default;
                };
            }
        };
    });